<template>
<router-view></router-view>
</template>

<script>

export default {
    name: "ProductsPage",
}
</script>

<style scoped>

</style>